export default {
	logado:null,
	notification:[]
}